import React from "react";

export default function Alert({ children }: React.PropsWithChildren<{}>) {
  return <div className="alert alert-warning">{children}</div>;
}
